import script from "./HTpvpTFGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTpvpTFGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTpvpTFGamePlay.vue?vue&type=style&index=0&id=306456ce&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306456ce"]])

export default __exports__